/* eslint-disable no-underscore-dangle */
import {
  fetchCategories,
  fetchCategory,
  useFetchCategories,
  useFetchCategory,
} from "@/apis/queryFunctions/categoryFunctions";
import {
  useFetchProductCount,
  useFetchProducts,
} from "@/apis/queryFunctions/productFunctions";
import { categoryKeys, productKeys } from "@/apis/queryKeys";
import ImageComponent from "@/common/ImageComponent";
import Container from "@/common/Layout/Container/Container";
import ProductCard from "@/common/ProductCard";
import { Box, Grid, Pagination, Skeleton, Text } from "@mantine/core";
import { HiOutlineEmojiSad } from "@react-icons/all-files/hi/HiOutlineEmojiSad";
import { QueryClient, dehydrate } from "@tanstack/react-query";
import { useRouter } from "next/router";
import React from "react";

export default function () {
  const {
    query: { slug },
    query,
  } = useRouter();
  console.log("data", slug);
  const [page, setPage] = React.useState(1);
  const [optionsProducts, setOptionsProducts] = React.useState({});
  const [arrCategory, setArrCategory] = React.useState([]);

  const { data: category } = useFetchCategory(slug || null);

  const { data: subcategories } = useFetchCategories(
    category?.ma_danh_muc
      ? {
          condition: {
            danh_muc_me: category?.ma_danh_muc,
          },
        }
      : null
  );

  React.useEffect(() => {
    // if (subcategories?.length === 0) {
    //   subcategories.push(category.ma_danh_muc);
    // }
    const arrCategory = [];
    if (subcategories?.length === 0) {
      arrCategory.push(category.ma_danh_muc);
      setArrCategory(arrCategory);
      return;
    }

    subcategories &&
      subcategories.map((item) => arrCategory.push(item.ma_danh_muc));

    setArrCategory(arrCategory);
  }, [subcategories]);

  const [fetchingOpion, setFetchingOption] = React.useState({});

  React.useEffect(() => {
    if (query?.sort !== "all") {
      setFetchingOption({
        ma_danh_muc_cty: { $in: [`${query?.sort}`] },
      });
    }
    if (query?.sort === "all") {
      setFetchingOption({
        ma_danh_muc_cty: { $in: arrCategory },
      });
    }
  }, [query?.sort, arrCategory]);

  const {
    data: products,
    isLoading,
    isFetched,
  } = useFetchProducts(
    category?.ma_danh_muc
      ? {
          condition: fetchingOpion,
          page,
        }
      : null
  );

  const { data: productCount } = useFetchProductCount(optionsProducts);

  React.useEffect(() => {
    if (category) {
      setOptionsProducts({
        options: {
          condition: fetchingOpion,
        },
      });
    }
  }, [category, fetchingOpion]);

  console.log("productsss", products);
  return (
    <Box>
      <Box
        pos="relative"
        sx={{
          width: "100%",
          aspectRatio: "2.9",
        }}
      >
        {category && category?.image ? (
          <ImageComponent src={category?.image} size="xl" layout="fill" />
        ) : (
          <Skeleton
            w="100%"
            sx={{
              aspectRatio: "2.9",
            }}
          />
        )}
      </Box>
      <Container>
        <Box
          sx={(theme) => ({
            margin: "70px 0 20px",
            [theme.fn.smallerThan("md")]: {
              margin: "30px 15px",
            },
          })}
        >
          <Grid>
            {isFetched && products?.length === 0 && (
              <Box
                sx={() => ({
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexGrow: 1,
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: 40,
                  paddingBottom: 40,
                })}
              >
                <HiOutlineEmojiSad size={32} />
                <Text mt={8}>Không tìm thấy sản phẩm</Text>
              </Box>
            )}
            {(isLoading ? new Array(16).fill({}) : products)?.map(
              (product, i) => (
                <Grid.Col sm={6} md={4} lg={4} xl={3} key={product._id || i}>
                  <ProductCard product={product} isLoading={isLoading} />
                </Grid.Col>
              )
            )}
          </Grid>
          <Pagination
            page={page}
            onChange={setPage}
            color="green"
            total={Math.ceil(+productCount / 16) || 1}
            position="center"
            mt="md"
          />
        </Box>
      </Container>
    </Box>
  );
}

export async function getStaticPaths() {
  const categories = await fetchCategories({});

  const paths = (categories || []).map((category) => ({
    params: { slug: String(category.slug) },
  }));

  return {
    paths,
    fallback: "blocking",
  };
}

export async function getStaticProps({ params = {} }) {
  const slug = params?.slug;

  const queryClient = new QueryClient();

  const category = await fetchCategory(slug);
  const optionsProducts = {
    condition: {
      ma_danh_muc_cty: category?.ma_danh_muc,
    },
    page: 1,
  };

  await queryClient.prefetchQuery(
    categoryKeys.detail(slug),
    () => fetchCategory(slug),
    {
      staleTime: 1000 * 60 * 60,
      enabled: !!slug,
    }
  );

  await queryClient.prefetchQuery(productKeys.list(optionsProducts));

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60,
  };
}
